var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeparateSectionsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-dc-tpl": 3545,
    viewBox: "56 0 140 179",
    width: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Outline sections, not yet written into a document",
    style: {
      display: "block",
      maxWidth: 152,
      height: "auto"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-dc-tpl": 3546,
    d: "M64 2.5H188C192.142 2.5 195.5 5.85786 195.5 10V169C195.5 173.142 192.142 176.5 188 176.5H64C59.8579 176.5 56.5 173.142 56.5 169V10C56.5 5.85786 59.8579 2.5 64 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-dc-tpl": 3547,
    d: "M64 2.5H188C192.142 2.5 195.5 5.85786 195.5 10V169C195.5 173.142 192.142 176.5 188 176.5H64C59.8579 176.5 56.5 173.142 56.5 169V10C56.5 5.85786 59.8579 2.5 64 2.5Z",
    stroke: "#E6E6E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3548,
    width: 37,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 15.5)",
    fill: "#B3B3B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3549,
    width: 116,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 28.5)",
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3550,
    x: 56,
    y: 36.5,
    width: 140,
    height: 1,
    fill: "#DFE0E3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3551,
    width: 37,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 50.5)",
    fill: "#B3B3B3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3552,
    width: 116,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 63.5)",
    fill: "#E6E6E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3553,
    x: 56,
    y: 71.5,
    width: 140,
    height: 1,
    fill: "#DFE0E3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3554,
    width: 37,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 85.5)",
    fill: "#B3B3B3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3555,
    width: 116,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 98.5)",
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3556,
    x: 56,
    y: 106.5,
    width: 140,
    height: 1,
    fill: "#DFE0E3"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3557,
    width: 37,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 120.5)",
    fill: "#B3B3B3"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3558,
    width: 116,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 133.5)",
    fill: "#E6E6E6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3559,
    x: 56,
    y: 141.5,
    width: 140,
    height: 1,
    fill: "#DFE0E3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3560,
    width: 37,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 155.5)",
    fill: "#B3B3B3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 3561,
    width: 116,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 68 168.5)",
    fill: "#E6E6E6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeparateSectionsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SeparateSectionsIcon.a035f8e90d41cb17b678cf571b35480f.svg";